export default __webpack_public_path__ + "static/media/any_profile_pic.6aa44f9d.png";